import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './SurveyCallBackTasks.css';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

const Item = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const styles = {
  inputLabelStyle: {
    color: '#929292',
    textAlign: 'left',
    paddingLeft: '20px',
    paddingBottom: '10px',
    font: 'normal normal normal 14px/19px Open Sans',
    fontSize: 'large',
    fontWeight: '800',
  },
  radioLabelStyle: {
    color: '#929292',
    textAlign: 'left',
    paddingBottom: '10px',
    font: 'normal normal normal 14px/19px Open Sans',
    fontWeight: '800',
  },
};

const SurveyCallBackTasks = props => {
  const [error, setError] = useState(false);

  const nextClicked = e => {
    let errorFound = false;
    for (const val in props.taskDetails) {
      if (props.taskDetails[val] === '') {
        errorFound = true;
        setError(true);
      }
    }

    if (!errorFound) {
      setError(false);
      props.next(e);
    }
  };

  const handleChange = event => {
    props.handleTaskDetailsChange(event);
  };

  return (
    <div
      id="callInfoDiv"
      style={{
        display: 'flex',
        justiyContent: 'space-between',
        flexDirection: 'column',
      }}
    >
      <div id="pageTitle">
        <p className="surveyHeading">TASK INFORMATION</p>
        <hr className="hr" />
      </div>
      <Grid container rowSpacing={0} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12}>
          <FormControl sx={{ paddingLeft: '20px' }}>
            <FormLabel
              id="demo-row-radio-buttons-group-label"
              sx={styles.radioLabelStyle}
            >
              Was Employee successfully reached?
            </FormLabel>
            <RadioGroup
              id="successfullyReached"
              name="successfullyReached"
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              defaultValue="Yes"
              onChange={handleChange}
            >
              <Box
                sx={{
                  border: 1,
                  borderColor: 'divider',
                  paddingLeft: '10px',
                  borderRadius: '8px',
                  backgroundColor:
                    props.taskDetails.successfullyReached === 'Yes'
                      ? '#E9F0F6'
                      : '',
                }}
              >
                <FormControlLabel
                  value="Yes"
                  control={
                    <Radio
                      checked={props.taskDetails.successfullyReached === 'Yes'}
                    />
                  }
                  label="Yes"
                />
              </Box>
              <Box
                sx={{
                  border: 1,
                  borderColor: 'divider',
                  marginLeft: '30px',
                  paddingLeft: '10px',
                  borderRadius: '8px',
                  backgroundColor:
                    props.taskDetails.successfullyReached === 'No'
                      ? '#E9F0F6'
                      : '',
                }}
              >
                <FormControlLabel
                  value="No"
                  control={
                    <Radio
                      checked={props.taskDetails.successfullyReached === 'No'}
                    />
                  }
                  label="No"
                />
              </Box>
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <Item>
            <InputLabel
              shrink
              htmlFor="callback-number"
              sx={styles.inputLabelStyle}
            >
              Callback Phone Number
            </InputLabel>
            <TextField
              id="callback-number"
              name="callBackNumber"
              variant="outlined"
              size="small"
              onChange={handleChange}
              value={props.taskDetails.callBackNumber}
              required
              error={error && props.taskDetails.callBackNumber === ''}
              helperText={
                error && props.taskDetails.callBackNumber === ''
                  ? 'Required'
                  : ''
              }
              inputProps={{
                style: {
                  paddingLeft: '40px',
                },
              }}
            />
          </Item>
        </Grid>
      </Grid>
      <Grid
        container
        rowSpacing={0}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        style={{ paddingBottom: '100px' }}
      >
        <Grid item xs={6}>
          <Item>
            <InputLabel shrink htmlFor="reason" sx={styles.inputLabelStyle}>
              Callback Topic
            </InputLabel>
            <TextField
              id="reason"
              name="callBackTopic"
              variant="outlined"
              size="small"
              multiline
              rows={4}
              onChange={handleChange}
              value={props.taskDetails.callBackTopic}
              required
              error={error && props.taskDetails.callBackTopic === ''}
              helperText={
                error && props.taskDetails.callBackTopic === ''
                  ? 'Required'
                  : ''
              }
              inputProps={{
                style: {
                  paddingLeft: '40px',
                },
              }}
            />
          </Item>
        </Grid>
      </Grid>
      <div
        id="buttonContainer"
        style={{ background: 'white' }}
        className="buttonContainer"
      >
        <hr className="hr" />
        <Stack spacing={2} direction="row">
          <Button
            id="backButton"
            variant="outlined"
            style={{
              borderRadius: '20px',
              opacity: 1,
              marginBottom: '10px',
              width: '40%',
              left: '10%',
            }}
            onClick={props.back}
          >
            Back
          </Button>
          <Button
            id="nextButton"
            variant="contained"
            style={{
              background: '#127CB7',
              borderRadius: '20px',
              opacity: 1,
              marginBottom: '10px',
              width: '40%',
              left: '10%',
            }}
            onClick={nextClicked}
          >
            Next
          </Button>
        </Stack>
      </div>
    </div>
  );
};

SurveyCallBackTasks.propTypes = {
  taskDetails: PropTypes.shape({
    successfullyReached: PropTypes.string,
    callBackNumber: PropTypes.string,
    callBackTopic: PropTypes.string,
  }).isRequired,
  handleTaskDetailsChange: PropTypes.func.isRequired,
  next: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
};

export default SurveyCallBackTasks;
